import { SidePanel } from '@all-manager/design-system-v2';
import ActivityTimeline from "../ActivityTimeline/ActivityTimeline";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  subTopicId: string;
};

export default function HistoryDrawer(props: Props) {
  return (
    <SidePanel
      open={props.isOpen}
      onClose={props.onClose}
      title="Historique"
      subtitle="Toute l'activité du sous-sujet, la plus récente en premier."
      closeLabel="Fermer l'historique"
    >
      {props.isOpen ? <ActivityTimeline subTopicId={props.subTopicId} /> : null}
    </SidePanel>
  );
}
